import React from "react";

import styles from "./style.module.css";

import { Button } from "aible";

import { ALERT_TYPES } from "containers/Monitoring/reducer";

import { FAIRNESS_OBJECTIVE } from "containers/Project/reducer";

export default class FairnessAlertCard extends React.PureComponent {
  getLabel(titleOverride) {
    const { setupLabels, fairnessObjective, fairnessToleranceBound } = this.props;
    let retTitle = titleOverride !== undefined ? titleOverride : "Monitoring Fairness";
    switch (fairnessObjective) {
      case FAIRNESS_OBJECTIVE.TRUE_POSITIVE_RATE:
        retTitle += `: Equal ${setupLabels.truePositiveLabel} Rate`;
        break;
      case FAIRNESS_OBJECTIVE.ALLOCATION:
        retTitle += `: Representative Share`;
        break;
      case FAIRNESS_OBJECTIVE.FALSE_POSITIVE_RATE:
        retTitle += `: Equal ${setupLabels.falsePositiveLabel} Rate`;
        break;
      case FAIRNESS_OBJECTIVE.ODDS:
        retTitle += `: Equal Odds`;
        break;
      case FAIRNESS_OBJECTIVE.ACCURACY:
        retTitle += `: Equal Accuracy`;
        break;
      case FAIRNESS_OBJECTIVE.NONE:
      default:
        break;
    }
    return retTitle;
  }

  render() {
    const label = this.getLabel("Fairness Issue Detected");
    return (
      <div className={styles.alertCardWrapper}>
        <AlertCardHeader alertLabel={label} {...this.props} />
        <AlertCardBody alertLabel={label} {...this.props} />
      </div>
    );
  }
}

class AlertCardHeader extends React.PureComponent {
  getHeader() {
    const { fairnessToleranceBound, fairnessWarnings, alertLabel } = this.props;
    let retHeader = alertLabel;
    return retHeader;
  }

  render() {
    return <div className={styles.alertCardHeader}>{this.getHeader()}</div>;
  }
}

class AlertCardBody extends React.PureComponent {
  getContent() {
    const { fairnessWarnings, fairnessObjective, fairnessToleranceBound, setupLabels } = this.props;

    let retAlert = "Monitoring results exceed your allowed max difference";

    switch (fairnessObjective) {
      case FAIRNESS_OBJECTIVE.TRUE_POSITIVE_RATE:
        retAlert = `The difference in ${setupLabels.truePositiveLabel} Rate`;
        break;
      case FAIRNESS_OBJECTIVE.FALSE_POSITIVE_RATE:
        retAlert = `The difference in ${setupLabels.falsePositiveLabel} Rate`;
        break;
      case FAIRNESS_OBJECTIVE.ODDS:
        retAlert = `The difference in Odds of ${setupLabels.truePositiveLabel}`;
        break;
      case FAIRNESS_OBJECTIVE.ACCURACY:
        retAlert = `The difference in Accuracy`;
        break;
      case FAIRNESS_OBJECTIVE.ALLOCATION:
      case FAIRNESS_OBJECTIVE.NONE:
      default:
        return retAlert;
    }

    retAlert += ` exceeds the maximum allowed difference of ${fairnessToleranceBound}% for ${fairnessWarnings.map(
      (w, i) => {
        let retSubgroup = `${w.label} (${(w.value * 100).toFixed(2)}%)`;
        if (i >= fairnessWarnings.length - 1) {
          return " and " + retSubgroup;
        }
        if (fairnessWarnings.length > 2) {
          retSubgroup += ", ";
        }
        return retSubgroup;
      }
    )}`;

    return retAlert;
  }
  render() {
    const { adjustAssumptions, hideAdjust } = this.props;
    return (
      <div className={styles.alertCardBody}>
        <div className={styles.alertCardContent}>{this.getContent()}</div>
        {!hideAdjust && (
          <div className={styles.alertCardFooter}>
            <Button onClick={() => adjustAssumptions()} style={{ width: "100%" }}>
              {"Adjust Assumptions"}
            </Button>
          </div>
        )}
      </div>
    );
  }
}
